import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";
import { Loader2, XCircle } from "lucide-react";

export default function VoucherConfirm() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [msg, setMsg] = useState("Confirming your payment…");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const vid = sp.get("vid");
    const session_id = sp.get("session_id");
    if (!vid || !session_id) { setFailed(true); setMsg("Missing payment details."); return; }
    api.get(`/voucher/confirm`, { params: { vid, session_id } })
      .then(({ data }) => {
        if (data.status === "paid" && data.code) {
          nav(`/voucher/${data.code}?new=1`, { replace: true });
        } else {
          setFailed(true); setMsg("Payment not completed.");
        }
      })
      .catch(() => { setFailed(true); setMsg("We couldn't confirm your payment."); });
  }, [sp, nav]);

  return (
    <div className="min-h-screen gp-hero-gradient flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl p-10 text-center max-w-[420px]">
        {failed ? <XCircle className="text-red-500 mx-auto" size={40} /> : <Loader2 className="animate-spin text-[#2ec9c9] mx-auto" size={40} />}
        <p className="text-[#16243b] font-medium mt-4">{msg}</p>
      </div>
    </div>
  );
}
